export enum ActionBarStatus {
    None,
    NotRequired,
    LoanConditions,
    UploadDocument,
    InstallationConfirmation,
    SendContractSigningReminder,
    NewLoanConditions
}
